import React, { useContext, useEffect } from "react";
import Grid from "@mui/material/Grid";
import { LOGS_CONST } from "../components/LogsConst";
import Channels from "./components/Channels/Channels";
import Messages from "./components/Messages/Messages";
import Loader from "./components/Loader/Loader";
import Device from "./components/Device/Device";
import IndustrySelector from "./components/IndustrySelector/IndustrySelector";
import Platforms from "./components/Platforms/Platforms";
import { makeStyles } from "@mui/styles";
import MyContext from "../StoreContext";
import logoWird from "./components/Loader/assets/wird-purpura.webp";

const StylesAuto = makeStyles({
  body: {
    flexDirection: "column",
    justifyContent: "center",
    alignitems: "center",
    display: "flex",
    height: "calc(100vh - 54px)",
  },
  mainContainer: {
    display: "flex",
    flexWrap: "nowrap",
    alignContent: "center",
    justifyContent: "space-around",
  },
  stepOne: {
    display: "flex",
    justifyContent: "flex-start",
    gap: "32px",
    width: "250px",
  },
  loaderContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "210px",
  },
  platformContainer: {
    width: "220px",
  },
});

/**
 * Componente principal donde se importan todas las secciones
 * de las automatizaciones
 */
const Automation = () => {
  const classes = StylesAuto();
  const { industry, message, channel, showPlatform } = useContext(MyContext);

  useEffect(() => {
    console.log(LOGS_CONST);
  }, []);

  return (
    <Grid container={true} className={classes.body}>
      <Grid container className={classes.mainContainer}>
        <Grid className={classes.stepOne} flexDirection='column'>
          <IndustrySelector />
          {industry && <Channels />}
          {channel && <Messages />}
        </Grid>

        <Grid item>
          <Device />
        </Grid>

        <Grid className={classes.loaderContainer}>
          {message ? (
            <Loader />
          ) : (
            <img src={logoWird} alt='logoWird' width={90} height={34} />
          )}
        </Grid>

        <Grid item className={classes.platformContainer}>
          {showPlatform && <Platforms />}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Automation;
